import { useState } from "react";
import { Coins, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "./ui/switch";
import { api, C, errorMessage } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// Cash-game chip options: both are applied by the server between hands, so they work even if you tab away.
export const AutoChipsSection = () => {
  const { user, refresh } = useAuth();
  const [busy, setBusy] = useState(null);
  const set = async (field, value, label) => {
    setBusy(field);
    try {
      await api.patch(C.ApiRoutes.PROFILE, { [field]: value });
      await refresh();
      toast.success(`${label} ${value ? "on" : "off"}`);
    } catch (e) { toast.error(errorMessage(e)); } finally { setBusy(null); }
  };
  const Row = ({ field, icon: Icon, label, hint }) => (
    <div className="flex items-center justify-between gap-4 py-3 border-b border-amber-200/10" data-testid={`setting-${field.replace("_", "-")}`}>
      <div className="flex items-start gap-3">
        <Icon className="w-4 h-4 gold-text shrink-0 mt-0.5" />
        <div><div className="text-sm text-amber-50">{label}</div><div className="text-[11px] text-slate-400 mt-0.5">{hint}</div></div>
      </div>
      <Switch data-testid={`${field.replace("_", "-")}-toggle`} disabled={busy === field} checked={!!user?.[field]}
        onCheckedChange={(c) => set(field, c, label)} />
    </div>
  );
  return (
    <section data-testid="drawer-auto-chips">
      <h3 className="flex items-center gap-2 text-xs uppercase tracking-[0.3em] gold-text mb-2"><Coins className="w-4 h-4" /> Chips at the table</h3>
      <Row field="auto_topup" icon={Coins} label="Auto top-up"
        hint="Between hands, bring a short stack back up to the amount you sat down with" />
      <Row field="auto_rebuy" icon={RotateCcw} label="Auto re-buy"
        hint="Bust and the same buy-in is taken again automatically, so you keep your seat" />
      <p className="text-[11px] text-slate-500 mt-2">Cash games only, and only while your wallet has the chips. Tournament stacks are never topped up.</p>
    </section>
  );
};
